export default "__VITE_ASSET__ef09a5b6__"